import { useQuery } from '@tanstack/react-query';
import type { CategoryAttributeSummary, CategoryNode } from '@biyolink/shared';
import { getData } from './client';

export const categoryKeys = {
  tree: ['categories', 'tree'] as const,
};

/** Kategori ağacı nadiren değişir; uzun süre önbellekte tutulur. */
export function useCategories() {
  return useQuery({
    queryKey: categoryKeys.tree,
    queryFn: () => getData<CategoryNode[]>('/categories'),
    staleTime: 10 * 60 * 1000,
  });
}

/** Form select'i için düzleştirilmiş liste: ana kategori → alt kategoriler. */
export function flattenCategories(
  tree: CategoryNode[] | undefined,
): { parent: CategoryNode; children: CategoryNode[] }[] {
  return (tree ?? []).map((parent) => ({ parent, children: parent.children }));
}

/**
 * Bir kategorinin ürün kriterleri (docs/09 §1.4). Aynı uç hem satıcının ilan formunu
 * hem alıcının filtre rayını besler — müşterinin kuralı kriterlerin tek kaynaktan
 * gelmesiydi.
 */
export function useCategoryAttributes(categoryId: string | null | undefined) {
  return useQuery({
    queryKey: ['categories', categoryId, 'attributes'] as const,
    queryFn: () => getData<CategoryAttributeSummary[]>(`/categories/${categoryId}/attributes`),
    enabled: Boolean(categoryId),
    staleTime: 5 * 60_000,
  });
}
